import React from "react";

interface EyebrowProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** Optional numeric prefix rendered as `01 — `. */
  step?: string | number;
  /** Total in series, rendered as `01 / 04 — `. Requires `step`. */
  of?: string | number;
}

export function Eyebrow({ step, of, className = "", children, ...rest }: EyebrowProps) {
  const prefix =
    step !== undefined
      ? of !== undefined
        ? `${String(step).padStart(2, "0")} / ${String(of).padStart(2, "0")} — `
        : `${String(step).padStart(2, "0")} — `
      : "";

  const cls = [
    "font-mono text-eyebrow uppercase",
    "text-coffee-600 dark:text-cream-200",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <span className={cls} {...rest}>
      {prefix}
      {children}
    </span>
  );
}

export default Eyebrow;
